import Footer from "../layout/Footer";
import Header from "../layout/Header";
import Integration from "./Integration";
import NewIntegration from "./NewIntegration";
import OrdableApiKey from "./OrdableApiKey";

const Ordable = () => {
  return (
    <div className="d-flex flex-column flex-root">
      {/*begin::Page*/}
      <div className="page d-flex flex-row flex-column-fluid">
        {/*begin::Wrapper*/}
        <div
          className="wrapper d-flex flex-column flex-row-fluid"
          id="kt_wrapper"
        >
          <Header />
          <div className="app-body">
            <div className="toolbar py-3 py-lg-6" id="kt_toolbar">
              {/*begin::Container*/}
              <div
                id="kt_toolbar_container"
                className=" container-xxl  d-flex flex-stack flex-wrap gap-2"
              >
                {/*begin::Page title*/}
                <div className="page-title d-flex flex-column align-items-start me-3 py-2 py-lg-0 gap-2">
                  {/*begin::Title*/}
                  <h1 className="d-flex text-dark fw-bold m-0 fs-3">Ordable</h1>
                  {/*end::Title*/}
                </div>
                {/*end::Page title*/}
              </div>
              {/*end::Container*/}
            </div>
            {/*end::Toolbar*/}

            {/*begin::Container*/}
            <div
              id="kt_content_container"
              className="d-flex flex-column-fluid align-items-start  container-xxl "
            >
              <div className="content flex-row-fluid" id="kt_content">
                {/*begin::API Key*/}
                <OrdableApiKey />
                {/*end::API Key*/}
                {/*begin::New Integration*/}
                <NewIntegration />
                {/*end::New Integration*/}
                {/*begin::Integration*/}
                <Integration />
                {/*end::Integration*/}
              </div>
            </div>
          </div>
          <Footer />
        </div>
        {/*end::Wrapper*/}
      </div>
      {/*end::Page*/}
    </div>
  );
};

export default Ordable;
